import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      marginTop: '25px',
      padding: '10px'
    }}>
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="pagination-btn"
        style={{
          padding: '8px 16px',
          borderRadius: '10px',
          background: 'rgba(30, 41, 59, 0.4)',
          border: '1px solid var(--glass-border)',
          color: currentPage === 1 ? '#475569' : 'white',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          fontSize: '13px',
          fontWeight: '600',
          transition: 'all 0.3s ease'
        }}
      >
        <i className="fa-solid fa-chevron-left" style={{ marginRight: '8px' }}></i> Anterior
      </button>

      <div className="pagination-info" style={{
        fontSize: '13px',
        fontWeight: '700',
        color: 'var(--p-slate)',
        background: 'rgba(30, 41, 59, 0.2)',
        padding: '8px 16px',
        borderRadius: '10px',
        border: '1px solid var(--glass-border)'
      }}>
        Página <span style={{ color: 'var(--p-navy)' }}>{currentPage}</span> de <span style={{ color: 'var(--p-navy)' }}>{totalPages}</span>
      </div>

      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="pagination-btn"
        style={{
          padding: '8px 16px',
          borderRadius: '10px',
          background: 'rgba(30, 41, 59, 0.4)',
          border: '1px solid var(--glass-border)',
          color: currentPage === totalPages ? '#475569' : 'white',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          fontSize: '13px',
          fontWeight: '600',
          transition: 'all 0.3s ease'
        }}
      >
        Siguiente <i className="fa-solid fa-chevron-right" style={{ marginLeft: '8px' }}></i>
      </button>
    </div>
  );
};

export default Pagination;
